export class SaveCurrentPositionDataDto {
  constructor(data) {
    this.name = data.name;
    this.course_id = data.course_id;
    this.language_id = data.language_id;
  }
}
